import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Component } from 'react';
import { ExceptionParser } from '../ExceptionParser';
import { Exception } from './Exception';
import { BackgroundException } from './BackgroundException';
export var LogEntry =
/*#__PURE__*/
function (_Component) {
  _inherits(LogEntry, _Component);

  function LogEntry() {
    var _this;

    _classCallCheck(this, LogEntry);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LogEntry).call(this));
    _this.exceptionParser = new ExceptionParser();
    return _this;
  }

  _createClass(LogEntry, [{
    key: "render",
    value: function render() {
      if (this.isBackgroundJobException()) {
        return this.renderBackgroundException();
      } else if (this.isException()) {
        return this.renderException();
      } else {
        return this.renderBasic();
      }
    }
  }, {
    key: "renderBasic",
    value: function renderBasic() {
      return React.createElement("span", null, this.props.message);
    }
  }, {
    key: "renderException",
    value: function renderException() {
      var exceptionData = this.exceptionParser.parse(this.props.message);
      return React.createElement(Exception, exceptionData);
    }
  }, {
    key: "renderBackgroundException",
    value: function renderBackgroundException() {
      var exceptionData = this.exceptionParser.parse(this.props.message);
      return React.createElement(BackgroundException, exceptionData);
    }
  }, {
    key: "isBackgroundJobException",
    value: function isBackgroundJobException() {
      return this.exceptionParser.isBackgroundJobException(this.props.message);
    }
  }, {
    key: "isException",
    value: function isException() {
      return this.exceptionParser.isException(this.props.message);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LogEntry;
}(Component);
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LogEntry, "LogEntry", "/srv/http/owncloud/apps/logreader/js/Components/LogEntry.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();